module.exports = __webpack_public_path__ + "static/Grupo 63-0bffdc72e8c91814d13211c596aa048f.svg";